import type { Event } from '../services/events';

type NamedEvent = Pick<Event, 'id' | 'name' | 'archived'>;

export function normalizeEventName(name: string): string {
  return name.trim().replace(/\s+/g, ' ').toLowerCase();
}

export function findDuplicateEventName(
  name: string,
  events: NamedEvent[],
  excludeEventId?: string,
): NamedEvent | null {
  const normalized = normalizeEventName(name);
  return events.find((event) => event.id !== excludeEventId && normalizeEventName(event.name) === normalized) ?? null;
}

export function duplicateEventNameMessage(match: Pick<Event, 'name' | 'archived'>): string {
  if (match.archived) {
    return `You already have an archived event named "${match.name}". Find it in your archive, or pick a different name.`;
  }
  return `You already have an event named "${match.name}". Pick a different name.`;
}
